import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { ClockIcon } from 'lucide-react';
export function TimeObjectionSection() {
  return <AnimatedSection className="px-4 py-8 md:py-14" data-id="element-108">
      <div className="max-w-3xl mx-auto text-center" data-id="element-109">
        <ClockIcon className="w-10 h-10 text-[#d4a853] mx-auto mb-6" data-id="element-110" />
        <h2 className="font-playfair text-2xl md:text-3xl font-bold mb-6" data-id="element-111">
          ¿No tienes tiempo? <span className="text-[#d4a853]" data-id="element-112">Perfecto.</span>
        </h2>
        <p className="text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-113">
          Este sistema está diseñado para el emprendedor ocupado. Copia de la
          bóveda, pega en Nano, y tienes un anuncio listo{' '}
          <span className="text-white font-semibold" data-id="element-114">
            antes de que se enfríe tu café.
          </span>
        </p>
      </div>
    </AnimatedSection>;
}